import { connect } from 'react-redux';
import { fetchRoles } from '../../../redux/actions/roles&permissions/roles';
import Roles from './Roles';

const mapStateToProps = (state) => ({
  roles: state.roles.roles,
  totalPermissions: state.roles.totalPermissions,
});
const mapDispatchToProps = (dispatch) => ({
  fetchRoles: () => dispatch(fetchRoles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
